'use client';

import * as React from 'react';
import reducer, { initialState } from './reducer.js';
import { ELanguage } from '../../Utils/constants.js';

var ApplyJobsContext = React.createContext({
    state: initialState,
    dispatch: function () { return null; },
    globalProps: {
        accessToken: '',
        langCode: ELanguage.VI,
        translator: function () { return ''; },
        user: null,
        jobInfo: null,
        baseMsUrl: '',
        baseUrl: '',
        multiple: false,
        initData: {
            locations: [],
            jobFunctions: { parent: [], child: {} },
            companyIndustries: [],
            jobLevels: [],
            educations: [],
            countries: [],
            cities: [],
            districts: {},
            benefits: []
        },
        isMobile: false,
        enableTracking: false
    }
});
function useApplyJobsState() {
    return React.useContext(ApplyJobsContext).state;
}
function useApplyJobsDispatch() {
    return React.useContext(ApplyJobsContext).dispatch;
}
function useApplyJobsProps() {
    return React.useContext(ApplyJobsContext).globalProps;
}
function ApplyJobsProvider(_a) {
    var children = _a.children, globalProps = _a.globalProps;
    var _b = React.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    return React.createElement(ApplyJobsContext.Provider, { value: { state: state, dispatch: dispatch, globalProps: globalProps } }, children);
}

export { ApplyJobsProvider as default, useApplyJobsDispatch, useApplyJobsProps, useApplyJobsState };
//# sourceMappingURL=provider.js.map
